<template>
  <div class="custom-dialog-header">
      <span class="custom-dialog-header-title">
        <svg-icon :icon-class="icon" style="font-size:14px !important"></svg-icon> 
        <span style="margin-left: 3px">{{ title }}</span>  
      </span>
      
      <span class="custom-dialog-header-close">
        <i :class="closeIcon" @click.stop="close"></i>
      </span>
      
    </div>
</template>

<script>
  export default {
    name: 'dialogHeader',
    props: {
      title: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: 'icon-dialog-add'
      },
      closeIcon: {
         type: String,
        default: 'el-icon-close'
      }
    },
    methods: {
      close(){
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
.custom-dialog-header{
  height: 46px;
  clear: both;
  line-height: 46px;
  color: #fff;
  .custom-dialog-header-title{
    float: left;
    margin-left: 15px;
  }
  .custom-dialog-header-close{
    float: right;
    margin-right: 15px;
    font-weight: bold;
    cursor: pointer;
    .el-icon-close{
      font-size: 16px !important;
       vertical-align: middle;
       
    }
  } 
}
</style>